type SectionLike = {
    url: string;
    forms?: { url?: string }[] | null;
};

/**
 * Relativ sti til en seksjon: `${section.url}/${form.url}` når seksjonen har
 * skjema (første eller siste), ellers bare `${section.url}`. Seksjoner uten
 * forms (f.eks. oppsummering, brukerinfo) skal ikke krasje navigasjonen.
 */
export function sectionPath(section: SectionLike, which: "first" | "last" = "first"): string {
    const forms = section.forms;
    if (forms && forms.length) {
        const form = which === "last" ? forms[forms.length - 1] : forms[0];
        if (form?.url) return `${section.url}/${form.url}`;
    }
    return section.url;
}
